import { GridColumnDataType } from '@infragistics/igniteui-angular';

import { NumberType } from './enums/number-type';
import { GridColumnConfig } from './grid-column.config';

export class GridNumberColumnConfig extends GridColumnConfig {
    format?: string;
    numberType: NumberType = NumberType.Default;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    displayValue = true;

    constructor(init?: Partial<GridNumberColumnConfig>) {
        super(init);

        if (!!init) {
            Object.assign(this, init);
        }

        this.dataType = GridColumnDataType.Number;
    }
}
